import * as ProjectUtils from '../project-utils';
import $ from 'jquery';

function disable(map) {
  map.dragging.disable();
  map.touchZoom.disable();
  map.doubleClickZoom.disable();
  map.scrollWheelZoom.disable();
  map.boxZoom.disable();
  map.keyboard.disable();
}

function enable(map) {
  map.dragging.enable();
  map.touchZoom.enable();
  map.doubleClickZoom.enable();
  // map.scrollWheelZoom.enable();
  map.boxZoom.enable();
  map.keyboard.enable();
}

function getPaddingTop() {
  if ($('html').hasClass('is-embed-mode')) {

    if (ProjectUtils.is500Query()) {
      return 30;
    }
    return 0;
  }

  if (ProjectUtils.is1600Query()) {
    return 270;
  } else if (ProjectUtils.is1400Query()) {
    return 190;
  } else if (ProjectUtils.is960Query()) {
    return 180;
  } else if (ProjectUtils.is500Query()) {
    return 210;
  } else if (ProjectUtils.is400Query()) {
    return 190;
  } else if (ProjectUtils.is375Query()) {
    return 180;
  } else {
    return 180;
  }
}

function getLabels() {
  let labels = [
    { name: '', latlng: [53.5584902,9.7877416], position: 'left' },
    { name: 'Hamburg', latlng: [53.5584902,9.7877416], position: 'left' },
    { name: 'Düsseldorf', latlng: [51.2384339,6.7443112], position: 'right' },
    { name: 'Stuttgart', latlng: [48.7791878,9.1071762], position: 'right' },
    { name: 'München', latlng: [48.1548895,11.4717967], position: 'left' },
    { name: 'Kiel', latlng: [54.3417926,10.0556381], position: 'left' },
    { name: 'Mainz', latlng: [49.9653659,8.1724916], position: 'left' },
    { name: 'Saarbrücken', latlng: [49.2471361,6.9124993], position: 'right' },
    { name: 'Wiesbaden', latlng: [50.0724615,8.1783144], position: 'right' },
    { name: 'Erfurt', latlng: [50.9853195,10.9452965], position: 'left' },
    { name: 'Dresden', latlng: [51.0768128,13.7025467], position: 'left' },
    { name: 'Magdeburg', latlng: [52.1259454,11.571798], position: 'right' },
    { name: 'Bremen', latlng: [53.1199492,8.5962058], position: 'right' },
    { name: 'Schwerin', latlng: [53.615894,11.3307936], position: 'right' },
    { name: 'Potsdam', latlng: [52.4283409,12.9573733], position: 'left' },
    { name: 'Hannover', latlng: [52.3796457,9.6914325], position: 'left' },
    { name: 'Berlin', latlng: [52.5067614,13.2846517], position: 'right' }
  ];

  if (ProjectUtils.is768Query()) {
    //labels.push({ name: 'Oberbaumbrücke ', latlng: [52.5018,13.4435], position: 'right' });
  }

  return labels;
}


export default {
  disable,
  enable,
  getPaddingTop,
  getLabels
}